import { defineStore } from 'pinia';
import axios from 'axios';

export default defineStore('axiosAPI Store', {
  state: () => ({
    token: {},
    tokenValid: false,
  }),
  actions: {
    // API function
    async axiosFun(url, method, data = null) {

      // const token = JSON.parse(localStorage.getItem('token')) || null;
      const token = {};
      token.accessToken = this.getCookieByName('accessToken');
      token.refreshToken = this.getCookieByName('refreshToken');

      if (!token) {
        await this.$router.push({ name: 'loginPage' });
        return null;
      };

      this.token = token;
      axios.defaults.headers.common["Authorization"] = `Bearer ${this.token.accessToken}`;

      if (!data) {
        return await axios[`${method}`](url).then((response) => {
          return response.data;
        }).catch((error) => {
          return this.catchError(error);
        })
      } else {
        return await axios[`${method}`](url, data).then((response) => {
          return response.data;
        }).catch((error) => {
          return this.catchError(error);
        })
      }

    },
    // 錯誤處裡
    async catchError(error) {
      console.log(error, 'error');

      if (error.message === 'Network Error') {
        throw new Error('error.message Network Error');
      }

      const url = error.config.url;
      const method = error.config.method;
      const axiosData = error.config.data;

      const message = error.response.data;

      switch (message) {
        // Token 格式錯誤
        case 'Token format error': {
          console.log('Token format error');
          break;
        }
        case 'Token 過期': {
          // console.log(this.token, 'Token 過期');

          const data = {
            refreshToken: this.token.refreshToken,
          }

          axios.defaults.headers.common = {};

          this.token = await this.actionRefreshToken(data);

          if (!this.token) return null;

          // console.log(this.token, 'this.token 過期後取得');

          localStorage.setItem('token', JSON.stringify(this.token));
          this.setCookieByName('accessToken', this.token.accessToken);
          this.setCookieByName('refreshToken', this.token.refreshToken);

          axios.defaults.headers.common["Authorization"] = `Bearer ${this.token.accessToken}`;

          // console.log(this.token, axios.defaults.headers.common["Authorization"]);

          // console.log(axiosData, !axiosData, 'axiosData');
          // console.log(url, method, 'method');
          
          // 重新執行
          if (!axiosData) {
            return await axios[`${method}`](url).then((response) => response.data);
          }

          return await axios[`${method}`](url, axiosData).then((response) => response.data);
        }
      }
    },
    // 檢查 RefreshToken 以更新 AccessToken
    async actionRefreshToken(data) {
      const url = `${process.env.VUE_APP_APIPATH_B}BackendManagement/RefreshExpToken`;

      return await axios.post(url, data).then((response) => {
        // console.log(response, 'actionRefreshToken');
        return response.data;
      }).catch(async (error) => {
        console.log(error, '檢查 RefreshToken 以更新 AccessToken');

        const message = error.response.data;

        if ('Token 過期' === message) {
          await this.$router.push({ name: 'loginPage' });
          return null;
        };
      })
    },
    // 檢查 RefreshToken 以更新 AccessToken
    async actionRefreshToken(data) {
      const url = `${process.env.VUE_APP_APIPATH_B}BackendManagement/RefreshExpToken`;

      return await axios.post(url, data).then((response) => {
        return response.data;
      }).catch(async (error) => {
        const message = error.response.data;

        if ('Token 過期' === message) {
          const path = window.location.href;
          localStorage.setItem('path', path);
          this.setCookieByName('path', window.location.href);
          window.location.href = `${process.env.VUE_APP_LOGIN}`;
          next(false);
          return null;
        };
      })
    },
    // 檢查 AccessToken 是否過期，true 是沒過期
    async checkValidAccessToken(accessToken) {
      return await axios.get(`${process.env.VUE_APP_APIPATH_B}BackendManagement/CheckValidAccessToken?AccessToken=${accessToken}`).then((res) => {
        return res.data;
      }).catch((error) => {
        console.error(error, 'check axiosAPI api: CheckValidAccessToken');
      })
    },
    // 檢查 token 是否在 localStorage，以及當前是否過期，沒過就是 false
    async checkToken() {
      // const judgeToken = localStorage.getItem('token') || null;
      const judgeToken = {};
      judgeToken.accessToken = this.getCookieByName('accessToken');
      judgeToken.refreshToken = this.getCookieByName('refreshToken');

      
      // 無 Token
      if (!judgeToken.accessToken) {
        return false;
      }

      // const token = JSON.parse(judgeToken);
      const token = judgeToken;
      const tokenValid = await this.checkValidAccessToken(token.accessToken);

      // 過期，flase 是過期
      if (!tokenValid) {
        return false;
      }

      return true;
    },
    parseCookie() {
        let cookieObj = {};
        let cookieAry = document.cookie.split('; ');
        let cookie;
        
        for (let i=0, l=cookieAry.length; i<l; ++i) {
            if(cookieAry[i].includes('=')){
            cookie = cookieAry[i].split('=');
            cookieObj[cookie[0]] = cookie[1];
            }
        }
        return cookieObj;
    },
    getCookieByName(name) {
        let value = this.parseCookie()[name];
        if (value) 
            value = decodeURIComponent(value);
        return value;
    },
    deleteCookieByName(key){
      document.cookie = `${key}=;domain=${process.env.VUE_APP_COOKIE_DOMAIN};path=/; expires=Sat, 7 Nov 1975 00:00:00 GMT;`;
    },
    // 設置 Cookie
    setCookieByName(key, value) {
      document.cookie = `${key}=${value};domain=${process.env.VUE_APP_COOKIE_DOMAIN};max-age=2592000;path=/;`;
    }
  }
})